import React, { useEffect, useState } from "react";
import { Card, Button, Input, Popconfirm, Select, message, Space } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "@/ag-grid-overrides.css";
import { deleteArticle, getArticles, getUsers } from "@/services/api";
import { useTheme } from "@/contexts/ThemeContext";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";

const months = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
];

const Articles = () => {
  const { isDark } = useTheme();
  const [articles, setArticles] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filterWriter, setFilterWriter] = useState(null);
  const [filterMonth, setFilterMonth] = useState(null);
  const [filterYear, setFilterYear] = useState(null);
  const [isLoading, setisLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [pagination, setpagination] = useState({});
  const [changePage, setchangePage] = useState(1);

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [filterWriter, changePage, filterMonth, filterYear]);

  const fetchUsers = async () => {
    try {
      const { data, isError } = await getUsers();
      if (isError) {
        return message.error("Failed to fetch users");
      }
      const activeUser = data?.data?.filter((v) => v?.isVerified);
      setUsers(activeUser || []);
    } catch (error) {
      message.error("Failed to fetch users");
    }
  };

  const fetchData = async () => {
    setisLoading(true);
    try {
      const [articlesRes] = await Promise.all([
        getArticles({
          limit: 50,
          author: filterWriter,
          page: changePage,
          month: filterMonth,
          year: filterYear,
        }),
      ]);
      setArticles(articlesRes.data.data);
      setpagination(articlesRes.data?.pagination);
      // setWriters(writersRes.data.data);
      // setCategories(categoriesRes.data.data);
      setisLoading(false);
    } catch (error) {
      message.error("Failed to fetch data");
      setisLoading(false);
    }
  };

  const handleDeleteArticle = async (article) => {
    try {
      await deleteArticle(article.uid);
      message.success("Article deleted successfully");
      fetchData();
    } catch (error) {
      message.error("Failed to delete article");
    }
  };

  const columnDefs = [
    {
      headerName: "S.No",
      valueGetter: "node.rowIndex + 1",
      width: 60,
      cellStyle: { fontSize: "13px" },
    },
    {
      field: "title",
      headerName: "Title",
      cellStyle: { fontSize: "13px" },
      width: 350,
      cellRenderer: (params) => (
        <Link className="w-80" title={params.title}>
          {params.value}
        </Link>
      ),
      filter: true,
      resizable: true,
    },
    // { field: "title", headerName: "Title", flex: 1, filter: true },
    {
      field: "author",
      headerName: "Writer",
      cellStyle: { fontSize: "13px" },
      width: 100,
      filter: true,
      resizable: true,
      cellRenderer: (params) => params.value.name,
    },
    {
      field: "category",
      headerName: "Category",
      width: 130,
      filter: true,
      cellStyle: { fontSize: "13px" },
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 120,
    //   cellRenderer: (params) => {
    //     const colors = {
    //       published: "success",
    //       draft: "warning",
    //       disabled: "default",
    //     };
    //     return (
    //       <Tag
    //         color={colors[params.value]}
    //         style={{
    //           borderRadius: 0,
    //           fontWeight: 500,
    //           fontSize: 11,
    //           textTransform: "uppercase",
    //         }}
    //       >
    //         {params.value}
    //       </Tag>
    //     );
    //   },
    // },
    // {
    //   field: "views",
    //   headerName: "Views",
    //   width: 100,
    //   cellStyle: { fontFamily: "JetBrains Mono, monospace" },
    // },
    {
      field: "date",
      headerName: "Published",
      width: 130,
      cellStyle: { fontSize: "13px" },
      cellRenderer: ({ value }) => moment(value).format("DD MMM, YYYY hh:mm a"),
    },
    {
      field: "updatedon",
      headerName: "Updated",
      width: 130,
      cellStyle: { fontSize: "13px" },
      cellRenderer: ({ value }) => moment(value).format("DD MMM, YYYY hh:mm a"),
    },
    {
      field: "deleted",
      headerName: "Status",
      width: 80,
      filter: true,
      cellRenderer: (params) => (
        <Space>
          <Button
            size="small"
            danger={params.data.deleted}
            style={{ borderRadius: 0, fontWeight: 500 }}
            data-testid={`toggle-user-${params.data.id}`}
          >
            {params.data.deleted ? "Deleted" : "Active"}
          </Button>
        </Space>
      ),
    },
    {
      headerName: "Actions",
      width: 110,
      cellRenderer: (params) => (
        <Popconfirm
          title="Delete Article"
          description={`Delete "${params.data.title}"?`}
          onConfirm={() => handleDeleteArticle(params.data)}
          okText="Delete"
          cancelText="Cancel"
        >
          <Button
            size="small"
            danger
            style={{ borderRadius: 0, fontWeight: 500 }}
            data-testid={`delete-article-${params.data.uid}`}
          >
            Delete
          </Button>
        </Popconfirm>
      ),
    },
  ];

  function handlePageClick({ selected }) {
    setchangePage(selected + 1);
  }

  const onCellClicked = (event) => {
    if (event.colDef.field === "title") {
      window.open(
        `https://media24hr.com/article/${event.data?.uid}/${event.value?.replaceAll(/[^a-zA-Z0-9]+/g, "-")}`,
      );
    }
    // console.log(event.data); // row data
    // console.log(event.value); // clicked cell value
    // console.log(event.colDef); // column info
  };
  return (
    <div>
      <div
        style={{
          marginBottom: 24,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: 28,
              fontWeight: 700,
              fontFamily: "IBM Plex Sans, sans-serif",
              letterSpacing: "-0.02em",
              marginBottom: 8,
            }}
          >
            Articles Management
          </h1>
          <p
            style={{
              fontSize: 14,
              color: isDark ? "#A1A1AA" : "#71717A",
              margin: 0,
            }}
          >
            Manage articles, writers, and content status
          </p>
        </div>
      </div>

      <Card
        style={{
          borderRadius: 0,
          border: `1px solid ${isDark ? "#27272A" : "#E4E4E7"}`,
          background: isDark ? "#18181B" : "#FFFFFF",
        }}
      >
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <Input
            placeholder="Search articles..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ maxWidth: 300, borderRadius: 0 }}
            data-testid="articles-search-input"
          />
          <Select
            placeholder="Filter by Writer"
            allowClear
            style={{ width: 180, borderRadius: 0 }}
            onChange={setFilterWriter}
            suffixIcon={<FilterOutlined />}
            data-testid="filter-by-writer"
          >
            {users.map((writer) => (
              <Select.Option key={writer.uid} value={writer.uid}>
                {writer.fullname}
              </Select.Option>
            ))}
          </Select>
          <Select
            placeholder="Filter by Month"
            allowClear
            style={{ width: 150, borderRadius: 0 }}
            onChange={setFilterMonth}
            suffixIcon={<FilterOutlined />}
            data-testid="filter-by-month"
          >
            {months.map((category) => (
              <Select.Option key={category.id} value={category.id}>
                {category.name}
              </Select.Option>
            ))}
          </Select>
          <Input
            placeholder="Enter Year.."
            prefix={<SearchOutlined />}
            value={filterYear}
            onChange={(e) => setFilterYear(e.target.value)}
            style={{ maxWidth: 150, borderRadius: 0 }}
            data-testid="articles-year-input"
          />
          {/* <Select
            placeholder="Filter by Status"
            allowClear
            style={{ width: 200, borderRadius: 0 }}
            onChange={setFilterStatus}
            suffixIcon={<FilterOutlined />}
            data-testid="filter-by-status"
          >
            <Select.Option value="published">Published</Select.Option>
            <Select.Option value="draft">Draft</Select.Option>
            <Select.Option value="disabled">Disabled</Select.Option>
          </Select> */}
        </div>
        <div
          className={isDark ? "ag-theme-alpine dark" : "ag-theme-alpine"}
          style={{ height: 600, width: "100%", fontSize: "14px" }}
        >
          <AgGridReact
            rowData={articles}
            columnDefs={columnDefs}
            // pagination={true}
            loading={isLoading}
            // paginationPageSize={pagination?.limit}
            // onPaginationChanged={(d) => console.log(d)}
            domLayout="normal"
            onCellClicked={onCellClicked}
          />
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={10}
            pageCount={pagination?.totalPages}
            previousLabel="<"
            renderOnZeroPageCount={null}
            // Container <ul>
            containerClassName="flex items-center justify-center space-x-1 mt-8"
            // Individual page <li> and <a>
            pageClassName="block border border-gray-300 rounded-md hover:bg-gray-100 transition-colors"
            pageLinkClassName="px-3 py-1 block"
            // Active page (concatenated to pageClassName)
            activeClassName="bg-black text-white border-blue-600 hover:bg-blue-700"
            // Previous/Next <li>
            previousClassName="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
            nextClassName="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
            // Break/Ellipsis <li>
            breakClassName="px-4 py-2"
            // Disabled state
            disabledClassName="opacity-50 cursor-not-allowed hover:bg-transparent"
          />
        </div>
      </Card>
    </div>
  );
};

export default Articles;
